import { Component } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { FooterComponent } from '../../../components/footer/footer.component';
import { StaticSearchComponent } from '../../../components/static-search/static-search.component';
import { CommonHeaderComponent } from '../../../components/common-header/common-header.component';
import { PDSService } from '../../../services/pds.service';
@Component({
  selector: 'app-top-cover',
  standalone: true,
  imports: [FooterComponent, StaticSearchComponent, CommonHeaderComponent],
  templateUrl: './top-cover.component.html',
  styleUrl: './top-cover.component.scss',
})
export class TopCoverComponent {
  partnerCode: string = '';
  constructor(
    private titleService: Title,
    private metaService: Meta,
    public pdsService: PDSService,
  ) {
    this.titleService.setTitle('Top Cover Travel Insurance | World2Cover');
    this.metaService.updateTag({
      name: 'description',
      content: `World2Cover Top Cover Travel Insurance covers overseas medical expenses, luggage, cancellations and more, with 24/7 emergency assistance.`,
    });
    this.metaService.updateTag({
      property: 'og:title',
      content: 'Top Cover Travel Insurance | World2Cover',
    });
    this.metaService.updateTag({
      property: 'og:description',
      content: `World2Cover Top Cover Travel Insurance covers overseas medical expenses, luggage, cancellations and more, with 24/7 emergency assistance.`,
    });
    this.partnerCode = this.pdsService.getWhiteLabelPartnerCode();
  }
}
